import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password) => setUser((await api.post("/auth/login", { email, password })).data);
  const register = async (form) => setUser((await api.post("/auth/register", { ...form, origin_url: window.location.origin })).data);
  const demoLogin = async () => setUser((await api.post("/public/demo-login")).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthContext.Provider value={{ user, setUser, login, register, demoLogin, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
